<!--  -->

<template>
  <div>

    <section class="main-content columns is-fullheight">

      <!-- menu laterale -->
      <Sidebar></Sidebar>

      <div class="column">
        <!-- contenuto -->
        <div>
          <keep-alive>
            <router-view/>
          </keep-alive>
        </div>
      </div>

    </section>


  </div>


</template>

<script>

import Sidebar from "./components/Sidebar";

export default {
  components: {
    Sidebar
  },

  data() {
    return {};
  },

  created() {

  },

  mounted() {

  },

  methods: {}


}
</script>

<style>

</style>
